import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import Notification from '@this/src/notification';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import { TableCell, TableRow } from '@this/src/components/shared/ui/data_displays/table';
import type AnaReservation from '@this/src/domain/arrangement/ana_reservation_total';
import type { ArrangerArgs } from '@this/src/domain/arranger/arranger';
import { Fetcher } from '@this/src/util';
import type { ReservationType } from '../../share/reservation_type';

interface Props {
  anaReservationTotal: AnaReservation;
  onApprove: () => void;
  reservationType: ReservationType;
}

interface ApproveResponse {
  ana_auto_reservation_total_approval: {
    reservation_date: string;
    approved_at: string;
    approved_by: ArrangerArgs;
  };
}

const AirAutoAnaReservationTotalTableRow: React.FC<Props> = observer(
  ({ anaReservationTotal, onApprove, reservationType }) => {
    const [loading, setLoading] = useState(false);

    const handleApprove = useCallback(() => {
      setLoading(true);
      const params = {
        reservation_date: anaReservationTotal.reservationDate.format('YYYY-MM-DD'),
        reservation_type: reservationType
      };
      Fetcher.post<ApproveResponse>(
        '/arrangement/auto_reservation_inventory/ana_booking/total/confirm.json',
        params
      )
        .then(res => {
          Notification.success(`${res.ana_auto_reservation_total_approval.reservation_date}の承認が完了しました`);
        })
        .finally(() => {
          setLoading(false);
          onApprove();
        });
    }, [anaReservationTotal, setLoading, reservationType]);

    return (
      <TableRow>
        <TableCell>{anaReservationTotal.reservationDate.format('YYYY-MM-DD')}</TableCell>
        <TableCell>{anaReservationTotal.aiOperatorCount?.toLocaleString() || 0}</TableCell>
        <TableCell>{anaReservationTotal.reservationCount?.toLocaleString() || 0}</TableCell>
        <TableCell>{anaReservationTotal.totalPrice?.toLocaleString() || 0}</TableCell>
        <TableCell>{anaReservationTotal.approvedAt?.format('YYYY-MM-DD') || '─'}</TableCell>
        <TableCell>{anaReservationTotal.approvedBy || '─'}</TableCell>
        <TableCell>
          {anaReservationTotal.approvedBy ? (
            <div style={{ padding: '8px 0' }}>確認済み</div>
          ) : (
            <Button onClick={handleApprove} loading={loading}>
              確認
            </Button>
          )}
        </TableCell>
      </TableRow>
    );
  }
);

export default AirAutoAnaReservationTotalTableRow;
